module.exports = __webpack_public_path__ + "img/tas_police_logo.4327dcae.png";